export function getApiBaseUrl(): string {
  if (typeof window !== "undefined") {
    // If in browser on localhost or 127.0.0.1 without reverse proxy
    if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
      return process.env.NEXT_PUBLIC_BACKEND_URL || "http://localhost:8000";
    }
    // On live domain (allfreepdftools.com), use same-origin relative URLs (/api/...)
    return process.env.NEXT_PUBLIC_BACKEND_URL || "";
  }
  return process.env.NEXT_PUBLIC_BACKEND_URL || "";
}
